import styled from '@emotion/styled';
import { useCommonModal } from 'hooks/useCommonModal';
import { Department } from 'models/admin/Department';
import { useEffect, useRef, useState } from 'react';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { GPopupTitle, GButtonBox } from 'components/layouts/GLayoutBox';
import { DialogTitleItem } from 'components/layouts/GModalPopup';
import { AgGridReact } from 'ag-grid-react';
import { useTranslation } from 'react-i18next';
import { GButton } from 'components/atom/button';
import Save from 'components/asset/images/Confirm.svg';
import Search from 'components/asset/images/Search.svg';
import SearchMolecule, {
  GButtonBoxCum,
  SearchItemWrap,
  SearchWrap,
  UnHiddenSearchWrap,
} from 'components/molecule/SearchMolecule';
import GButtonLayout from 'components/molecule/GbuttonLayout';
import { GContentGrid } from 'components/layouts/GContentGrid';
import { useColumnDefsForApprovalList } from './gridDef/ForeignDefs';
import { SampleResponse } from 'models/sample/Sample';
import { useMessageBar } from 'components/process/MessageBar';
import { useLoading } from 'components/process/Loading';
import { getSamples } from 'apis/sample/SampleApi';
import ModalLayout from 'components/layouts/ModalLayout';

type DepartmentModalProps = {
  open: boolean;
  singleSelect?: boolean;
  close: () => void;
  save: () => void;
};

const ForeignCurrencyBank = (props: DepartmentModalProps) => {
  const [sampleList, setSampleList] = useState<SampleResponse[]>([]);
  const gridApiRef = useRef<any>(null);
  const { defaultColDef, colDefs } = useColumnDefsForApprovalList();
  const { openMessageBar } = useMessageBar();
  const { openLoading } = useLoading();
  const { t } = useTranslation();
  const gridRef = useRef<AgGridReact<Department>>(null);
  const { openCommonModal } = useCommonModal();

  const handleError = (e: Error) => {
    openLoading(false);
    openMessageBar('error', e.message);
  };

  useEffect(() => {
    loadSampleList();
  }, []);

  const loadSampleList = async () => {
    getSamples(makeSearchParams())
      .then((data) => {
        setSampleList(data.list);
      })
      .catch(handleError);
  };

  const makeSearchParams = () => {
    return {
      start: '0',
      pageSize: 30,
    };
  };

  const handleClose = () => {
    props.close();
  };

  const handleOnSave = () => {
    const selectedRows = gridRef.current?.api.getSelectedRows() || [];
    if (selectedRows.length === 0) {
      openCommonModal({
        modalType: 'alert',
        content: t(
          'department-choice-popup.alert.한 부서 이상 선택해야 합니다.',
          '__선택된 행이 없습니다.'
        ),
      });
      return;
    }
    props.close();
  };

  return (
    <ModalLayout open={props.open} onClose={handleClose} mMinWidth={1000} mMaxWidth={1000}>
      <DialogTitleItem id="customized-dialog-title" onClose={handleClose}>
        <GPopupTitle title2="외화거래은행" />
      </DialogTitleItem>
      <DialogContent className="popupContent">
        <SearchWrap>
          <UnHiddenSearchWrap>
            <ItemWrap>
              <SearchMolecule
                type="input"
                labelTitle="은행이름"
                labelWidth="100px"
                placeholder="입력하세요"
                searchWidth="calc(50% - 12px)"
                searchValueWidth="100%"
              />
              <SearchMolecule
                type="input"
                placeholder="입력하세요"
                labelTitle="SWIFT/BIC"
                labelWidth="124px"
                searchWidth="calc(50% - 12px)"
                searchValueWidth="100%"
              />
            </ItemWrap>
            <GButtonLayout paddingTop="0px" marginBottom="0px">
              <GButtonBoxCum>
                <GButton
                  chkImg={Search}
                  txt="조회"
                  sizes="medium"
                  btnstyled="contained"
                  btnColor="normal"
                  hasImg={true}
                  hasTxt={true}
                ></GButton>
              </GButtonBoxCum>
            </GButtonLayout>
          </UnHiddenSearchWrap>
        </SearchWrap>
        <GContentGrid
          isSortable={false}
          className="ag-theme-alpine"
          style={{ height: '300px', marginTop: '4px' }}
        >
          <AgGridReact
            defaultColDef={defaultColDef}
            columnDefs={colDefs}
            rowData={sampleList}
            rowSelection={'multiple'}
            enableCellTextSelection
            onGridReady={(params) => (gridApiRef.current = params.api)}
            tooltipShowDelay={0}
            tooltipHideDelay={2000}
          ></AgGridReact>
        </GContentGrid>
      </DialogContent>
      <DialogActions className="popupBottom">
        <GButtonBox>
          <GButton
            txt="취소"
            sizes="medium"
            onClick={handleClose}
            btnstyled="outline"
            btnColor="normal"
            hasImg={false}
            hasTxt={true}
          />
          <GButton
            txt="저장"
            sizes="medium"
            onClick={handleOnSave}
            chkImg={Save}
            btnstyled="contained"
            btnColor="primary"
            hasImg={true}
            hasTxt={true}
          />
        </GButtonBox>
      </DialogActions>
    </ModalLayout>
  );
};

export default ForeignCurrencyBank;
const ItemWrap = styled(SearchItemWrap)`
  display: flex;
  gap: 24px;
`;
